import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'operation-result-check',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './operation-result-check.component.html',
  // The css is crazy, one day centering a div will be a sane task
  styleUrl: './operation-result-check.component.scss',
})
export class OperationResultCheckComponent implements OnInit {
  success: boolean = false;
  ngOnInit() {
    this.success = true;
  }
}
